/** Локальные копии серверных проектов для работы без подключения к сети. */
import type { Project } from "@/shared/store";

const DATABASE_NAME = "grid-planner";
const DATABASE_VERSION = 1;
const STORE_NAME = "projects";

export type LocalProject = {
	lastModifiedDate: string;
	project: Project;
	projectId: string;
	syncStatus: "pending" | "synced";
};

const requestResult = <T>(request: IDBRequest<T>): Promise<T> =>
	new Promise((resolve, reject) => {
		request.addEventListener("error", () => reject(request.error), { once: true });
		request.addEventListener("success", () => resolve(request.result), { once: true });
	});

const openDatabase = async (): Promise<IDBDatabase> => {
	const request = indexedDB.open(DATABASE_NAME, DATABASE_VERSION);
	request.onupgradeneeded = () => {
		if (!request.result.objectStoreNames.contains(STORE_NAME)) {
			request.result.createObjectStore(STORE_NAME, { keyPath: "projectId" });
		}
	};
	return requestResult(request);
};

export const getLocalProject = async (projectId: string): Promise<LocalProject | null> => {
	const database = await openDatabase();
	const transaction = database.transaction(STORE_NAME, "readonly");
	const result = await requestResult(transaction.objectStore(STORE_NAME).get(projectId));
	database.close();
	return (result as LocalProject | undefined) ?? null;
};

export const putLocalProject = async (project: LocalProject): Promise<void> => {
	const database = await openDatabase();
	const transaction = database.transaction(STORE_NAME, "readwrite");
	await requestResult(transaction.objectStore(STORE_NAME).put(project));
	database.close();
};
